
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotions",
      function () {
        return require("private-next-pages/promotions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotions"])
      });
    }
  